import styles from './TextWrapper.module.scss';

import cx from 'classnames';
import React from 'react';

import type { IEntryProp } from '../../IEntries';
import { TextBlock } from '../../TextBlock/TextBlock';

type TextWrapperProps = Pick<IEntryProp, Exclude<keyof IEntryProp, 'backgroundColor'>>;
export const TextWrapper: React.FC<TextWrapperProps> = ({ entry, first, className, ...props }) => {
  if (!entry?.fields) return null;

  const { topic } = entry.fields;

  return (
    <div className={cx(styles.textWrapper, className)} {...props}>
      <TextBlock entry={topic} className={styles.text} />
    </div>
  );
};
